import styled from 'styled-components';
import { device } from '../../constants';

export const Wrapper = styled.div.attrs({
    className: 'flex flex-col justify-center items-center',
})`
    background-color: #ffffff;
    position: fixed;
    width: 100%;
    height: 100%;
`;

export const Label = styled.label.attrs({
    className: 'text-black',
})`
    color: #6b7280;
    font-size: 3rem;
    font-weight: 500;
    margin-bottom: 40px;

    @media ${device.laptop} {
        font-size: 5rem;
    }
`;

export const ImgWrapper = styled.div`
    width: 40%;
    max-width: 250px;

    @media ${device.laptop} {
        width: 45%;
    }
`;

export const Img = styled.img`
    width: 100%;
    display: block;
    margin: 0 auto;
`;
